import { resultTabActionTypes } from './Constants';

const initialState = {
	summaryData: null,
	summaryLoading: true,
	testResultsData: null,
	testResultsLoading: true,
};

export default function resultTabReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case resultTabActionTypes.GET_RESULT_TAB_SUMMARY:
			return {
				...state,
				summaryLoading: true,
			};

		case resultTabActionTypes.GET_RESULT_TAB_SUMMARY_SUCCESS:
			return {
				...state,
				summaryData: data,
				summaryLoading: false,
			};

		case resultTabActionTypes.GET_RESULT_TAB_SUMMARY_ERROR:
			return {
				...state,
				summaryLoading: false,
			};

		case resultTabActionTypes.GET_RESULT_TAB_RESULTS:
			return {
				...state,
				testResultsLoading: true,
			};

		case resultTabActionTypes.GET_RESULT_TAB_RESULTS_SUCCESS:
			return {
				...state,
				testResultsData: data,
				testResultsLoading: false,
			};

		case resultTabActionTypes.GET_RESULT_TAB_RESULTS_ERROR:
			return {
				...state,
				testResultsLoading: false,
			};

		default:
			return state;
	}
}
